<template>
  <div class="m-page">
    <div class="m-page-banner dd-m-page-banner" :style="'background: url(' + currentPageBg.bg + ') no-repeat center; ' + 'background-size: cover'">
      <div class="m-page-mask dd-m-page-mask" :class="currentPageBg.idx === 1 ? 'm-element-transparency-dark': 'm-element-transparency-light'">
        <div :class="currentPageBg.idx === 1 ? 'm-element-display': 'm-element-hide'">
          <div class="m-page-label banner-label">
            <span>实施成果</span>
          </div>
          <div class="m-page-title">威龙电镀加工厂</div>
          <div class="m-page-sub-title banner-sub-title">专业电镀加工厂</div>
          <div class="m-group">
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-01.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">55%</div>
                <div class="m-item-sub-title">减少沟通和纸张的使用</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-02.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">60%</div>
                <div class="m-item-sub-title">降低数据汇总和分析时间</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-03.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">35%</div>
                <div class="m-item-sub-title">降低次品率及次品成本</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-04.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">35%</div>
                <div class="m-item-sub-title">工厂全面透明可视，协同效率提升</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-05.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">22%</div>
                <div class="m-item-sub-title">人员生产效率提升</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-06.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">3%</div>
                <div class="m-item-sub-title">设备OEE提升</div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="m-page-carousel">
          <el-carousel
            :autoplay="carousel.autoPlay"
            :indicator-position="carousel.indicatorPosition"
            type="card"
            height="108px"
            @change="choosePageBg">
            <el-carousel-item v-for="(item, index) in carouselImgList" :key="index">
              <div class="m-carousel-img-sign" v-if="item.idx === 1">
                <icon class="m-carousel-img-sign-icon" name="exclamation"></icon>
              </div>
              <img class="el-carousel-img" :src="item.icon" :class="currentPageBg.idx === item.idx ? 'el-carousel-img-active': ''"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="m-page-problem">
      <div class="m-page-label problem-label">
        <span>解决的问题</span>
      </div>
      <div class="m-problem-group">
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">人为抄数</div>
          <div class="m-p-g-item-desc">要依赖人手，无法大量、密集、准时采集全部数据</div>
        </div>
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">数据真伪</div>
          <div class="m-p-g-item-desc">数据的真伪存疑</div>
        </div>
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">数据实时性</div>
          <div class="m-p-g-item-desc">大量数据无法即时到达相关人员手中。更不要说及时处理和应用了</div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="m-page-solution">
      <div class="m-page-label solution-label">
        <span>我们如何做的</span>
      </div>
      <div class="m-page-diagram">
        <img src="../../../assets/img/case/case-mobile-diagram-02.png"/>
      </div>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import '../styles/mobile-page.scss'
export default {
  name: 'WLongMobilePage',
  data () {
    return {
      currentPageBg: {
        idx: 1,
        bg: require('../../../assets/img/case/dd/case-dd-page-bg-01.png')
      },
      carousel: {
        autoPlay: false,
        indicatorPosition: 'none'
      },
      carouselImgList: [
        {idx: 1, icon: require('../../../assets/img/case/dd/case-dd-page-bg-01.png'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/dd/case-dd-page-bg-02.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-02.jpg')},
        {idx: 3, icon: require('../../../assets/img/case/dd/case-dd-page-bg-04.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-04.jpg')},
        {idx: 4, icon: require('../../../assets/img/case/dd/case-dd-page-bg-05.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-05.jpg')},
        {idx: 5, icon: require('../../../assets/img/case/dd/case-dd-page-bg-06.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-06.jpg')},
        {idx: 6, icon: require('../../../assets/img/case/dd/case-dd-page-bg-07.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-07.jpg')},
        {idx: 7, icon: require('../../../assets/img/case/dd/case-dd-page-bg-08.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-08.jpg')},
        {idx: 8, icon: require('../../../assets/img/case/dd/case-dd-page-bg-09.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-09.jpg')},
        {idx: 9, icon: require('../../../assets/img/case/dd/case-dd-page-bg-10.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-10.jpg')}
      ]
    }
  },
  methods: {
    choosePageBg (idx) {
      let data = this.carouselImgList[idx]
      this.currentPageBg.idx = data.idx
      this.currentPageBg.bg = data.bg
    }
  }
}
</script>

<style scoped>
  .dd-m-page-banner {
    height: 840px;
  }
  .dd-m-page-mask {
    height: 840px;
  }
</style>



// WEBPACK FOOTER //
// src/views/case/components/DDuMobilePage.vue